module.exports = __webpack_public_path__ + "static/img/cp2.7a4c5af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp2.png
// module id = 25GE
// module chunks = 0